module.exports = __webpack_public_path__ + "img/search-bar-background.daf738da.svg";